<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">即時維修狀態</div>
      <div style="margin-top: 2rem">
        <div class="row">
          <div class="col-12 text-end">
            <exportCsv :type="'xlsx'" :exportData="exportData"
              :exportDataTitle="maintainStatusFields.map((item) => item.label)" :exportFileName="exportFileName" />
          </div>
          <div class="col-12 mt-3">
            <commonTable :fields="maintainStatusFields" :items="maintainStatusZiguanTableItems"
              :otherTheme="'tbody-green'" stickyHeader="350px">
              <template #header>梓官廠當前報修機台</template>
            </commonTable>
          </div>
          <div class="col-12" style="margin-top: 2rem">
            <commonTable :fields="maintainStatusFields" :items="maintainStatusQiaotouTableItems"
              :otherTheme="'tbody-green'" stickyHeader="350px">
              <template #header>岡山廠當前報修機台</template>
            </commonTable>
          </div>
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import commonTable from "@/components/commonTable.vue";
import exportCsv from "@/components/exportCsv.vue";
import { computed, inject, ref } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    commonTable,
    exportCsv,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const path = inject("path");
    const maintainStatusFields = ref([
      {
        key: "device",
        label: "機台",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "model",
        label: "型號",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "報修時間",
        thStyle: {
          "min-width": "200px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "reason",
        label: "報修原因",
        thStyle: {
          "min-width": "200px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
          "white-space": "pre-line",
        },
      },
      {
        key: "accumulation",
        label: "維修累積時間",
        thStyle: {
          "min-width": "200px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);
    const maintainStatusZiguanTableItems = ref([
      // {
      //   device: "鍛造1",
      //   time: "2023-11-10 11:20:00",
      //   category: 3,
      //   description: "入料夾手(Q1)機械異常維修",
      //   personnel: "小明1號",
      //   startTime: "2023-11-10 11:35:00",
      // },
      // {
      //   device: "退火3",
      //   time: "2023-11-12 10:47:00",
      //   category: 2,
      //   description: "排煙風機維修",
      //   personnel: "",
      //   startTime: "",
      // },
      // {
      //   device: "環形爐",
      //   time: "2023-11-13 14:35:00",
      //   category: 2,
      //   description: "夾手冷卻水管漏水",
      //   personnel: "",
      //   startTime: "",
      // },
    ]);

    const maintainStatusQiaotouTableItems = ref([
      // {
      //   abn_start_time: "2023-11-13 10:00:00",
      //   device: "保溫1",
      //   deviceID: "PH01",
      //   startTime: "2023-11-13 10:00:00",
      //   endTime: "2023-11-13 12:15:30",
      //   category: 3,
      //   personnel: "小明1號",
      //   totalTime: "2小時15分30秒",
      // },
      // {
      //   abn_start_time: "2023-11-14 10:00:00",
      //   device: "環形爐",
      //   deviceID: "R03",
      //   startTime: "2023-11-14 13:00:00",
      //   endTime: "2023-11-14 18:20:30",
      //   category: 2,
      //   personnel: "小明1號",
      //   totalTime: "5小時20分30秒",
      // },
    ]);

    const exportData = ref([]);
    const exportFileName = ref("");

    const setExportExcelData = (data) => {
      if (
        data.maintain_data_Ziguan.length == 0 &&
        data.maintain_data_Qiaotou.length == 0
      ) {
        return;
      }
      let fileName = "即時維修狀態" + data.query_time;
      let titleField = [];
      let titleKey = [];
      maintainStatusFields.value.forEach((item) => {
        titleKey.push(item.key);
        titleField.push(item.label);
      });
      let setExportData = [];
      Object.keys(data).forEach((item) => {
        if (item == "query_time") {
          return;
        }
        let thisExportData = [];
        data[item].forEach((rowData) => {
          let singleRowData = [];
          titleKey.forEach((key) => {
            singleRowData.push(rowData[key]);
          });
          thisExportData.push(singleRowData);
        });
        let sheetName = "";
        if (item == "maintain_data_Ziguan") {
          sheetName = "梓官廠機台報修紀錄";
        } else if (item == "maintain_data_Qiaotou") {
          sheetName = "岡山廠機台報修紀錄";
        }
        let exportObj = {
          sheetName: sheetName,
          title: titleField,
          data: thisExportData,
        };
        setExportData.push(exportObj);
      });
      exportData.value = setExportData;
      exportFileName.value = fileName;
    };

    const getMaintainData = () => {
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      console.log(path.value);
      params["methods"] = "GET";
      params["whichFunction"] = "Query_Maintain_Status";
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let queryTableData = result.QueryTableData;
          maintainStatusZiguanTableItems.value = queryTableData.maintain_data_Ziguan;
          maintainStatusQiaotouTableItems.value = queryTableData.maintain_data_Qiaotou;
          setExportExcelData(queryTableData);
        } else {
          maintainStatusZiguanTableItems.value = [];
          maintainStatusQiaotouTableItems.value = [];
          exportData.value = [];
          exportFileName.value = "";
          methods.setTimeoutAlert(response);
        }
        methods.triggerLoadingBar();
      });
    }

    getMaintainData();

    return {
      maintainStatusFields,
      maintainStatusZiguanTableItems,
      maintainStatusQiaotouTableItems,
      exportData,
      exportFileName,
    };
  },
};
</script>

<style></style>
